import { DEMO_LOGINS, ELoginAs } from '@aqx-core/common/api/auth';
import { ICompany } from '@aqx-core/common/api/config';

export const getRegistrationUrl = (companyProfile: ICompany | null | undefined, selectedTab: ELoginAs | undefined) => {
  if (!selectedTab) {
    return '';
  }
  const { companyRegistrationUrl, webtraderDemoRegistrationUrl, webtraderLiveRegistrationUrl } = companyProfile ?? {};

  if (selectedTab === ELoginAs.LIVE) {
    return companyRegistrationUrl ?? null;
  } else if (DEMO_LOGINS.includes(selectedTab)) {
    return webtraderDemoRegistrationUrl ?? null;
  }

  return webtraderLiveRegistrationUrl ?? null;
};
